import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { ProductMockup } from './ProductMockup';
const chips = ['6 Volumes', '40 Weeks', '300 Pages', '3 Levels per combo', '30 · 45 · 60-min versions', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or teach from your phone'];
export function Hero() {
  return <section className="w-full bg-plum-deep" data-id="element-115" data-mp="128fo9ew4a5tl">
      <div className="max-w-6xl mx-auto px-5 pt-8 pb-16 sm:pt-12 sm:pb-20" data-id="element-116" data-mp="1274n7mu23c66">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-12" data-id="element-117" data-mp="xb5rtfab8tw9">
          <div data-id="element-118" data-mp="s9q93tvluzh1">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-119" data-mp="sde3ev8vjpwt">
              Dance Class Ready · for teachers of kids ages 6–12
            </p>
            <h1 className="mt-4 font-display font-bold text-white text-[38px] leading-[1.06] tracking-tight sm:text-6xl md:text-[64px]" data-id="element-120" data-mp="3d2bidl8y6rtf">
              A full season of dance classes,{' '}
              <span className="text-coral" data-id="element-121" data-mp="3j9kc5f0exnhp">ready to teach.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-122" data-mp="3o85af8w3tx3i">
              Dance Class Ready is six volumes with a complete class for every
              week of a 40-week season — warm-up, skill, combo and game,
              counted in 8s and written in three levels so one plan fits the
              whole room. Open the week, pick your length, teach.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-123" data-mp="358hnqvly413m">
              {chips.map(chip => <li key={chip} className="rounded-full border border-plum-line px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-124" data-mp="2qk3kijkmaamj">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductMockup data-id="element-125" data-mp="2lkilk95g629t" />

        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-126" data-mp="2lk8uei8o1p2j">
          <div className="w-full max-w-md" data-id="element-127" data-mp="s2jmpvqkdyiz">
            <CtaButton data-id="element-128" data-mp="s3mbny4btqw9">Get Dance Class Ready</CtaButton>
          </div>
          <div className="mt-5" data-id="element-129" data-mp="nb1ohffxec1p">
            <RatingProof data-id="element-130" data-mp="na08cwk1yzd4" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-white/70" data-id="element-131" data-mp="ibyowaipsy14">
            Written for studio, after-school and community-center teachers who
            plan their own classes. No syllabus lock-in, no subscription.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-132" data-mp="1azkqxecanulv">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-133" data-mp="15zzr71pavi83">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-134" data-mp="111525i0qoxfj" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}